import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "reports" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Reports")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "col-sm-6 text-right"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-lg btn-primary mr-3",
  "data-toggle": "modal",
  "data-target": "#report-migrate-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-import" }),
  /*#__PURE__*/_createTextVNode(" Migrate Report ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-square" }, null, -1)
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-day" }, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "col-sm-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Region", -1)

import { ref, watch, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import moment from 'moment-timezone';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";

// Components
import ReportsList from "@/components/report/List.vue";
import ReportsSearchByMonth from "@/components/report/SearchByMonth.vue";
import ReportsSearchByString from "@/components/report/SearchByString.vue";
import ReportMigrateModal from "@/components/modals/ReportMigrateModal.vue";
import FilterByString from "@/components/report/FilterByString.vue";

// Types
import { Report, Office } from "@/models";

// Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const reportsState = ref(store.state.reports);
const isAdministrator = computed((): boolean => store.getters['auth/isAdministrator']);
const offices = computed((): Office[] => store.getters['offices/getOffices']);
const reports = computed((): Report[] => store.getters['reports/list']);

const currentoffice = ref();
// Methods
const getReports = (): Promise<any> => {
  return store.dispatch('reports/getReports');
};

const setMonth = (month: string): Promise<any> => {
  return store.dispatch('reports/setMonth', month);
};

const setSearch = (search: string): Promise<any> => {
  return store.dispatch('reports/setSearch', search);
};

const setFilter = (search: string): Promise<any> => {
  return store.dispatch('reports/setFilter', search);
};


const setCurrentPage = (page: number): Promise<any> => {
  return store.dispatch('reports/setCurrentPage', page);
};

const resetCurrentPage = (): Promise<any> => {
  return store.dispatch('reports/resetCurrentPage');
};

const setCurrentOffice = (office: string) => {
  return store.commit('reports/setCurrentOffice', office);
};

const officeNameOptions = computed(() => offices.value.map(o => o.name));

const onSelectOffice = async (officename: string) => {
  const office: Office = offices.value.find(o => o.name === officename);
  if (office?.id) {
    await setCurrentOffice(office.id);
    await getReports();
  }
};

const clearCurrentOffice = async () => {
  currentoffice.value = '';
  await setCurrentOffice('');
  await getReports();
};

const resetSearch = () => {
  if (route.query.month !== moment().format("YYYY-MM")) {
    router.push({
      path: "reports",
      query: { month: moment().format("YYYY-MM") },
    });
    resetCurrentPage();
  }
};

// Watchers
watch(() => route.query.month, async (newVal: any, oldVal: any) => {
  if (newVal) {
    await setMonth(newVal);
    await getReports();
  }
});

watch(() => route.query.search, async (newVal: any, oldVal: any) => {
  if (newVal) {
    await setSearch(newVal);
    await getReports();
  }
});

watch(() => route.query.filter, async (newVal: any, oldVal: any) => {
  if (newVal) {
    await setFilter(newVal);
    await getReports();
  }
});

watch(() => route.query.page, async (newVal: any, oldVal: any) => {
  if (newVal) {
    await setCurrentPage(newVal);
    await getReports();
  }
});

// Handle component creation logic
onMounted(() => {
  document.title = 'Reports';
  const queryParams = route.query;
  if (typeof queryParams.month === 'string' && queryParams.month.length) {
    const page = queryParams.page ? Number(queryParams.page) : 1;
    setCurrentPage(page);
    setMonth(queryParams.month).then(() => getReports());
  } else if ((typeof queryParams.search === 'string' && queryParams.search.length) || (typeof queryParams.filter === 'string' && queryParams.filter.length)) {
    if ((typeof queryParams.search === 'string' && queryParams.search.length) && (typeof queryParams.filter === 'string' && queryParams.filter.length)) {
      setSearch(queryParams.search);
      setFilter(queryParams.filter).then(() => getReports());
    } else if(typeof queryParams.search === 'string' && queryParams.search.length){
      setSearch(queryParams.search).then(() => getReports());
    } else if(typeof queryParams.filter === 'string' && queryParams.filter.length){
      setFilter(queryParams.filter).then(() => getReports());
    }
  } else if (reportsState.value.month) {
    router.push({
      path: "reports",
      query: { month: reportsState.value.month },
    });
  } else if (reportsState.value.search) {
    router.push({
      path: "reports",
      query: { text: reportsState.value.search },
    });
  } else {
   
    router.push({
      path: "reports",
      query: { month: moment().format("YYYY-MM") },
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (isAdministrator.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_router_link, {
                class: "btn btn-lg btn-primary",
                to: "/reports/new"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" New Report ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(ReportsSearchByMonth, { class: "col-sm-2" }),
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-outline-primary col-sm-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (resetSearch()))
      }, [
        _hoisted_8,
        _createTextVNode(" This month ")
      ]),
      _createVNode(ReportsSearchByString, {
        class: _normalizeClass(_unref(route).query.search &&  reports.value.length > 0 ? 'col-sm-3' : 'col-sm-6'),
        placeholder: "Search all reports"
      }, null, 8, ["class"]),
      (_unref(route).query.search && reports.value.length > 0)
        ? (_openBlock(), _createBlock(FilterByString, {
            key: 0,
            class: "col-sm-3",
            placeholder: "Filter all reports"
          }))
        : _createCommentVNode("", true),
      (isAdministrator.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_singleselect_text, {
              modelValue: currentoffice.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentoffice).value = $event)),
              options: officeNameOptions.value,
              onSelect: onSelectOffice,
              "allow-empty": true
            }, _createSlots({
              placeholder: _withCtx(() => [
                _hoisted_10
              ]),
              _: 2
            }, [
              (currentoffice.value)
                ? {
                    name: "clear",
                    fn: _withCtx(() => [
                      _createElementVNode("i", {
                        onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (clearCurrentOffice()), ["prevent","stop"])),
                        class: "multiselect__clear fa fa-times",
                        "aria-label": "Clear Region"
                      }, null, 32)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ReportsList),
    _createVNode(ReportMigrateModal)
  ]))
}
}

})